import { render, staticRenderFns } from "./PMobileCarouselBanner.vue?vue&type=template&id=7356fe9b&scoped=true&"
import script from "./PMobileCarouselBanner.vue?vue&type=script&lang=ts&"
export * from "./PMobileCarouselBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PMobileCarouselBanner.vue?vue&type=style&index=0&id=7356fe9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356fe9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VSheet})
